

import { createRoot } from 'react-dom/client';
import './style.scss';
import Style from './Style';
import Products from './Products';


// Block Directory
document.addEventListener('DOMContentLoaded', () => {
	const productSwipeEl = document.getElementById('bpwpsbProductSwiper');
	renderPlugin(productSwipeEl);
	const blockEls = document.querySelectorAll('.wp-block-bpwpsb-product-swiper');

	blockEls?.forEach(el => {
		renderPlugin(el);
	})
});


const renderPlugin = (el) => {
	if (el) {
		const attributes = JSON.parse(el?.dataset.attributes);
		createRoot(el).render(<>
			<Style attributes={attributes} id={el.id} />
			<RenderProducts attributes={attributes} />
		</>);

		el?.removeAttribute('data-attributes');
	}
}
export const RenderProducts = ({ attributes }) => {
	return <Products attributes={attributes}></Products>
}

